import { Type, type Static } from '@sinclair/typebox';
import { FIELD_LIMITS } from '../constants.js';
import { PaymentEventTypes } from '../enums.js';
import { IsoDateSchema, RowVersionField, SoftDeleteFields, TimestampFields, UuidSchema } from './common.js';

export const PaymentEventTypeSchema = Type.Union(PaymentEventTypes.map((value) => Type.Literal(value)));

export const PaymentEventSchema = Type.Object({
  id: UuidSchema,
  projectItemId: UuidSchema,
  eventType: PaymentEventTypeSchema,
  amountPaisa: Type.Integer({ minimum: 1 }),
  eventDate: IsoDateSchema,
  referenceNumber: Type.Union([Type.String({ maxLength: FIELD_LIMITS.REFERENCE_NUMBER_MAX }), Type.Null()]),
  remarks: Type.Union([Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX }), Type.Null()]),
  recordedByUserId: UuidSchema,
  ...TimestampFields,
  ...SoftDeleteFields,
  ...RowVersionField,
});
export type PaymentEvent = Static<typeof PaymentEventSchema>;

export const PaymentEventCreateSchema = Type.Object({
  eventType: PaymentEventTypeSchema,
  amountPaisa: Type.Integer({ minimum: 1 }),
  eventDate: IsoDateSchema,
  referenceNumber: Type.Optional(Type.Union([Type.String({ maxLength: FIELD_LIMITS.REFERENCE_NUMBER_MAX }), Type.Null()])),
  remarks: Type.Optional(Type.Union([Type.String({ maxLength: FIELD_LIMITS.NOTES_MAX }), Type.Null()])),
});
export type PaymentEventCreate = Static<typeof PaymentEventCreateSchema>;
